import request from '../utils/http'
const appid = 2005  // 不同小程序对接同一后台  5-维应生活服务开发版、2005-维应生活服务、6001-比鹏鸟

// 用户注册
export function register(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "reg",
            appid,
            ...data
        }  //接口参数
    })
}

// 管理员登录
export function login(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "login_admin",
            ...data
        }  //接口参数
    })
}

// 获取token park0
export function getToken() {
    return request({
        url: "/service/park.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "gettoken",
            appkey: 'park2023',
            appsecret: 'SefByUjaOTdgwFFUjzSOvwEsZLKvfmoI'
        }  //接口参数
    })
}

// 管理员登录获取开发id 273
export function adminGuid(data) {
    return request({
        url: "/service/user.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "getopenid",
            ...data
        }  //接口参数
    })
}

// 企业用户登录
export function userLogin(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login',
            appid,
            ...data
        }  //接口参数
    })
}

// 获取用户信息 198
export function getUserInfo(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'getuser',
            ...data
        }  //接口参数
    })
}


// 发送手机号 280
export function sendVerfity(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'sms',
            ...data
        }  //接口参数
    })
}

// 手机号验证 281
export function verifyPhoto(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login_mobile',
            appid,
            ...data
        }  //接口参数
    })
}

// 忘记登录密码（重置） 282
export function resetPass(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login_mobile_uppwd',
            appid,
            ...data
        }  //接口参数
    })
}

// 修改登录密码 279
export function updatePass(data) {
    return request({
        url: "/service/user.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'updatepwd',
            appid,
            ...data
        }  //接口参数
    })
}


// 图片上传 228
export function uploadImage(data) {
    return request({
        url: "/service_app/ImageUpload.ashx",  //接口路径
        method: "post",  //接口方法
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data  //接口参数
    })
}

// 获取省市 57
export function getProvince() {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'area'
        }
    })
}

// 获取城市 58
export function getCity(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'city',
            areaid: id
        }
    })
}

// 获取区域 286
export function getArea(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'addr',
            cityid: id
        }
    })
}

// 查看订单取餐信息 park9
export function getTakeMealInfo(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'pickupview',
            ...data
        }
    })
}

// 取餐员取餐 park8
export function getTakeMeal(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'pickupadd',
            ...data
        }
    })
}

// 送餐员送餐 park10
export function getSendMeal(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'deliveryadd',
            ...data
        }
    })
}

// 分配员送餐 park12
export function getDispatch (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'serinfoadd',
            ...data
        }
    })
}

// 分配员送餐 park12
export function addDispatch (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'serinfoedit',
            ...data
        }
    })
}

// 分派员扫码-放入大柜
export function putBigCabinet (data) {
    return request({
        url: '/service/cabinet/action.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getbig',
            ...data
        }
    })
}
// 分派员扫码-放入小柜
export function putSmallCabinet (data) {
    return request({
        url: '/service/cabinet/action.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getsmall',
            ...data
        }
    })
}

// 获取订单信息 park15
export function getOrderInfo(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'orderview',
            ...data
        }
    })
}

// 获取订单列表
export function getOrderList(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_order_list',
            ...data
        }
    })
}

// 获取投诉列表
export function getScoldList(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'scold_list',
            ...data
        }
    })
}

// 查询开箱状态
export function getBoxState(data) {
    return request({
        url: '/service/cabinet/action.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getboxstate',
            ...data
        }
    })
}

// 修改订单投诉审核状态 park23
export function scoldCheck(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'scold_check',
            ...data
        }
    })
}